import { createBrowserRouter, Navigate } from 'react-router';
import { lazy } from 'react';

import LoginRoutes from './auth';
import DashboardRoutes from './dashboard';
import AdminRoutes from './admin';
import { ErrorPage } from '@/components/ErrorPage';
import Loadable from '@/components/loadable';

const StreamTestPage = Loadable(lazy(() => import('@/pages/StreamTestPage')));

export const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/auth" replace />,
      },
      LoginRoutes,
      DashboardRoutes,
      AdminRoutes,
      {
        path: '/stream-test',
        element: <StreamTestPage />,
      },
      {
        path: '*',
        element: <ErrorPage />,
      },
    ],
  },
]);
